import styled from "styled-components";

export const Branding = () => {
  return (
    <BrandingParagraph>
      <FirstLetter>O</FirstLetter>rbital
      <br />
      <FirstLetter>O</FirstLetter>bject of
      <br />
      <FirstLetter>S</FirstLetter>
      pecial
      <br />
      <FirstLetter>I</FirstLetter>nterest
    </BrandingParagraph>
  );
};

export default Branding;

const FirstLetter = styled.span`
  /* font-size: 3.5rem;
  font-weight: 500;
  line-height: 1.3; */
  /* white-space: pre-wrap; */
  color: #e7c11d;
  font-size: 2rem;

  /* margin-right: 0.3rem; */
  /* background-color: #f9f9f9; */
  /* padding: 0.5rem; */
  /* border-radius: 0.5rem; */
  /* box-shadow: 0 0 1rem 0.5rem #f9f9f9; */
  /* transform: translateY(-0.2rem); */
  /* transition: all 0.5s;
  &:hover {
    transform: translateY(-0.5rem) scale(1.1);
  } */
`;

const BrandingParagraph = styled.p`
  /* padding-top: 1rem; */
  /* position: absolute;
  top: 10rem;
  right: 4rem; */
  white-space: pre;
  font-size: 1.5rem;

  font-weight: 600;

  line-height: 2rem;
  letter-spacing: 0.1rem;

  padding-bottom: 2rem;
`;
